import { render, staticRenderFns } from "./AlertHeading.vue?vue&type=template&id=78ba96e0&"
import script from "./AlertHeading.vue?vue&type=script&lang=js&"
export * from "./AlertHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports